import { useState, useEffect } from "react";
import { MonitorCog, QrCode, SlidersHorizontal } from "lucide-react";
import ChargerUiUpdate from "../ChargerUiUpdate";
import ChargerQRGenerator from "../QrString";
import "../../App.css";

const ChargerAndQR = () => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("chargerSettingTab") || "charger";
  });
 
  useEffect(() => {
    localStorage.setItem("chargerSettingTab", activeTab);
  }, [activeTab]);

  return (
    <div className="h-screen w-full max-w-full overflow-x-hidden overflow-y-auto hide-scrollbar bg-[radial-gradient(circle_at_10%_6%,rgba(255,255,255,0.34),transparent_30%),linear-gradient(90deg,#22d3ee_0%,#1398cf_48%,#0b5fa5_100%)] p-4 text-slate-50 md:p-6">
      <div className="mb-5 flex flex-col gap-4 rounded-lg border border-cyan-100/25 bg-slate-950/25 p-5 shadow-2xl shadow-blue-950/20 backdrop-blur-md md:flex-row md:items-end md:justify-between">
        <div className="min-w-0">
          <p className="mb-2 flex items-center gap-2 text-xs font-black uppercase text-cyan-100">
            <SlidersHorizontal size={16} />
            Charger display controls
          </p>
          <h1 className="m-0 text-2xl font-black text-white md:text-4xl">
            Charger Updates
          </h1>
          <p className="mt-2 max-w-2xl text-sm font-semibold text-cyan-50/80">
            Manage charger branding, gun display behavior, media schedule, and QR output.
          </p>
        </div>

        <div className="inline-flex w-full max-w-full gap-2 overflow-x-auto rounded-lg border border-cyan-100/20 bg-slate-950/35 p-1 md:w-auto">
          <button
            className={`inline-flex min-h-10 flex-1 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-black transition md:flex-none ${
              activeTab === "charger"
                ? "bg-white text-sky-950 shadow-lg"
                : "text-cyan-50 hover:bg-white/10 hover:text-white"
            }`}
            onClick={() => setActiveTab("charger")}
          >
            <MonitorCog size={17} />
            Charger UI
          </button>

          <button
            className={`inline-flex min-h-10 flex-1 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-black transition md:flex-none ${
              activeTab === "qr"
                ? "bg-white text-sky-950 shadow-lg"
                : "text-cyan-50 hover:bg-white/10 hover:text-white"
            }`}
            onClick={() => setActiveTab("qr")}
          >
            <QrCode size={17} />
            QR Generator
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === "charger" && (
        <div className="min-w-0 max-w-full">
          <ChargerUiUpdate />
        </div>
      )}

      {activeTab === "qr" && (
        <div className="min-w-0 max-w-full">
          <ChargerQRGenerator />
        </div>
      )}
    </div>
  );
};

export default ChargerAndQR;
